import { CalculatePriceResponse } from 'api/responseTypes';

export const calculateDiscountPercentage = (
  priceCalculation: CalculatePriceResponse | null | undefined,
): number | null => {
  if (!priceCalculation?.subTotal || !priceCalculation?.appliedPromoCodesAmount) {
    return null;
  }

  if (priceCalculation.appliedPromoCodesAmount <= 0) {
    return null;
  }

  return Math.round((priceCalculation.appliedPromoCodesAmount / priceCalculation.subTotal) * 100);
};
